import React, { useEffect } from "react";
import Navbar from "../components/homepage/Navbar";
 
import AllTenders from "../components/tenders/AllTenders";
import { Header, Footer } from "../shared";

const AllTendersPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <div className="bg_darkblue">
        <Header />
      </div>
      <AllTenders />
      <Footer />
    </div>
  );
};

export default AllTendersPage;
